module.exports = __webpack_public_path__ + "static/media/football_pitch.3edc8fc6.png";